import React from "react";
import { useAuth } from "@/context/AuthContext";
import { ProductCatalog } from "@/components/ProductCatalog";

export default function Products() {
  const { user: me } = useAuth();
  return (
    <div className="space-y-6" data-testid="products-page">
      <ProductCatalog isAdmin={me?.role === "admin"} />
    </div>
  );
}
